import { render, staticRenderFns } from "./AnswerReward.vue?vue&type=template&id=090dd370&scoped=true"
import script from "./AnswerReward.vue?vue&type=script&lang=js"
export * from "./AnswerReward.vue?vue&type=script&lang=js"
import style0 from "./AnswerReward.vue?vue&type=style&index=0&id=090dd370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090dd370",
  null
  
)

export default component.exports